const Login = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="card bg-base-100 shadow-sm text-center">
        <div className="card-body max-w-96 text-center">
          <h1 className="text-center text-xl font-bold">Anmeldung</h1>
          <p className="mt-2 mb-10">
            Der Muster-Onlinedienst ist eine geschlossene Veranstaltung. Bitte
            loggen Sie sich ein.
          </p>

          <div className="card-actions">
            <a
              href="/oauth2/authorization/gitlab"
              className="btn btn-primary btn-block"
            >
              Anmelden mit Gitlab (FITKO)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
